import { JetView } from 'webix-jet'; // Importing JetView class from webix-jet for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for the agent list table.
 * @extends JetView
 */
export default class tableAgentListView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Preserving the context of 'this' for later use

        /**
         * Custom checkbox template for displaying approval and rejection buttons.
         * @param {Object} obj - The data object for the row.
         * @param {Object} common - Common properties for the checkbox.
         * @param {string} value - The value determining the checkbox state.
         * @returns {string} - HTML string for the custom checkbox.
         */
        function custom_checkbox(obj, common, value) {
            if (value != 'N') return ''; // Return empty if value is not 'N'
            else
                return '<div style=" padding: 0px 14px;display: inline-block;background: green;color: #fff;font-size: 13px; " class=\'webix_table_checkbox webixbutton approbarbutton\'>A</div><div style=" padding: 0px 14px;display: inline-block;background: red;color: #fff;font-size: 13px;" class=\'webix_table_checkbox webixbutton rechazarbutton\'> N </div>'; // Return HTML for approval and rejection buttons
        }

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'Action', // Column ID for action buttons
                                    header: '', // No header
                                    template: custom_checkbox, // Custom template for checkboxes
                                    width: 100, // Column width
                                },
                                {
                                    id: 'detailTittle', // Column ID for detail icon
                                    header: '', // No header
                                    width: 50, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Detalles'), // Tooltip text
                                    template: function(obj) {
                                        return '<span class=\'webix_icon wxi-close details\'></span>'; // Icon for details
                                    },
                                },
                                {
                                    id: 'ActionTittle', // Column ID for action title
                                    header: '', // No header
                                    width: 70, // Column width
                                    height: 25, // Column height
                                    tooltip: 'Acción', // Tooltip text
                                    template: function(obj) {
                                        if (devConfig.getPermAction('agentListPay', 'Pay')) {
                                            return '<span placeholder=\'Pagar\' class=\'webix_icon wxi-close icon-tranfer2 prm-agentListPay\'></span>'; // Icon for payment action
                                        } else {
                                            return ''; // Return empty if no permission
                                        }
                                    },
                                },
                                {
                                    id: 'Name', // Column ID for name
                                    header: _('Nombre'), // Header text
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserId', // Column ID for user ID
                                    header: _('ID Usuario'), // Header text
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName', // Column ID for username
                                    header: _('Usuario'), // Header text
                                    width: 220, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Document', // Column ID for document number
                                    header: _('Número cédula'), // Header text
                                    width: 200, // Column width
                                },
                                {
                                    id: 'Email', // Column ID for email
                                    header: _('Email'), // Header text
                                    width: 220, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'State', // Column ID for state
                                    header: _('Estado'), // Header text
                                    options: [ // Options for state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                },
                                {
                                    id: 'StateValidate', // Column ID for validation state
                                    header: _('Estado Validación'), // Header text
                                    options: [ // Options for validation state dropdown
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                        { id: 'N', value: _('None') },
                                    ],
                                },
                                {
                                    id: 'RegionName', // Column ID for region name
                                    header: _('Región'), // Header text
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'DepartmentName', // Column ID for department name
                                    header: _('Departamento'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CityName', // Column ID for city name
                                    header: _('Ciudad'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CurrencyId', // Column ID for currency
                                    header: _('Moneda'), // Header text
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Phone', // Column ID for phone number
                                    header: _('Teléfono'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Address', // Column ID for address
                                    header: _('Dirección'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Ip', // Column ID for IP address
                                    header: _('Dirección IP'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedDate', // Column ID for creation date
                                    header: _('Fecha de creación'), // Header text
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'LastLoginDateLabel', // Column ID for last login date
                                    header: _('Fecha de ultimo login'), // Header text
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date format
                                },
                                {
                                    id: 'ModifiedLocal', // Column ID for modified date
                                    header: _('Modificado'), // Header text
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            editable: true, // Enable editing
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // ID for the pager
                            onClick: {
                                /**
                                 * Event handler for clicking the details icon.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                details: function(euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    if (vthis.getUrl()[0].page !== 'AgentListManagement')
                                        vthis.show(
                                            'agentListManagement?user=' + item.Id + '/agent.informationAgentList', // Show agent list management
                                        );
                                    else vthis.show('/agent.informationAgentList'); // Show information agent list
                                },
                                /**
                                 * Event handler for clicking the approve button.
                                 * @param {Event} ev - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                approbarbutton: function(ev, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    if (item.StateValidate == 'N') { // Check if state is 'N'
                                        const data = {
                                            Id: item.Id, // ID of the item
                                            Action: 'A', // Action to approve
                                        };
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(devConfig.geturlApi() + 'Agent/SetStateValidate', data, {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message(_('Error')); // Show error message
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text); // Parse response
                                                    if (json.HasError) {
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error', // Error type
                                                            text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                        });
                                                    } else {
                                                        item.StateValidate = 'A'; // Update state to approved
                                                        item.Action = 'A'; // Update action to approved
                                                        webix.message(_('Guardado')); // Show success message
                                                    }
                                                },
                                            });
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Error title
                                            type: 'alert-error', // Error type
                                            text: _('No puedes activar un registro ya actualizado.'), // Error message
                                        });
                                    }
                                },
                                /**
                                 * Event handler for clicking the reject button.
                                 * @param {Event} ev - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                rechazarbutton: function(ev, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    if (item.StateValidate == 'N') { // Check if state is 'N'
                                        const data = {
                                            Id: item.Id, // ID of the item
                                            Action: 'I', // Action to reject
                                        };
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(devConfig.geturlApi() + 'Agent/SetStateValidate', data, {
                                                error: function(text, data, XmlHttpRequest) {
                                                    webix.message('Error'); // Show error message
                                                },
                                                success: function(text, data, XmlHttpRequest) {
                                                    var json = JSON.parse(text); // Parse response
                                                    if (json.HasError) {
                                                        webix.message({
                                                            title: _('¡Error!'), // Error title
                                                            type: 'alert-error', // Error type
                                                            text: _('Ocurrio un error, comuniquese con soporte'), // Error message
                                                        });
                                                    } else {
                                                        item.StateValidate = 'I'; // Update state to rejected
                                                        item.Action = 'I'; // Update action to rejected
                                                        webix.message('Guardado'); // Show success message
                                                    }
                                                },
                                            });
                                    } else {
                                        webix.message({
                                            title: _('¡Error!'), // Error title
                                            type: 'alert-error', // Error type
                                            text: _('No puedes activar un registro ya actualizado.'), // Error message
                                        });
                                    }
                                },
                                /**
                                 * Event handler for clicking the pay button.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked row.
                                 */
                                pay: function(euv, id) {
                                    var vvthis = this; // Preserve context
                                    var item = vvthis.getItem(id); // Get the clicked item
                                    console.log(item); // Log the item
                                    webix
                                        .modalbox({
                                            title: _('¿ Qué desea realizar ?'), // Modal title
                                            buttons: [ // Modal buttons
                                                _('Traslado a Saldo Recargas'),
                                                _('Traslado a Saldo Juego'),
                                                _('Cancelar'),
                                            ],
                                            text: '', // Modal text
                                            width: 500, // Modal width
                                        })
                                        .then(function(result) { // Handle modal result
                                            switch (result) {
                                                case '0': // Transfer to recharge balance
                                                    webix
                                                        .ui({
                                                            view: 'window', // Window view
                                                            head: _('Transferir a saldo Recargas a ') + item.UserName, // Window header
                                                            id: 'windowTransfers', // Window ID
                                                            modal: true, // Modal window
                                                            position: 'center', // Center position
                                                            body: {
                                                                view: 'form', // Form view
                                                                id: 'windowTransfersForm', // Form ID
                                                                elements: [
                                                                    {
                                                                        view: 'text', // Text input for amount
                                                                        label: _('Monto'), // Label for input
                                                                        name: 'amount', // Input name
                                                                        id: 'amount', // Input ID
                                                                    },
                                                                    {
                                                                        cols: [ // Button layout
                                                                            {
                                                                                view: 'button', // Transfer button
                                                                                value: 'Transferir', // Button text
                                                                                click: function(elementId, event) {
                                                                                    var values =
                                                                                        $(
                                                                                            'windowTransfersForm', // Get form values
                                                                                        ).getValues();
                                                                                    var tthis = this; // Preserve context
                                                                                    webix
                                                                                        .ajax()
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                            'Agent/MakeAgentTransfers',
                                                                                            '{ "Id":' +
                                                                                            item.Id +
                                                                                            ',"Amount":' +
                                                                                            values.amount +
                                                                                            ',"Type":0}', // Transfer data
                                                                                            {
                                                                                                error: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        _('Error! '), // Show error message
                                                                                                    );
                                                                                                },
                                                                                                success: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var data =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse response
                                                                                                        );
                                                                                                    if (data.HasError) {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'No Se ha realizado la transferencia. Comunicarse con soporte. ', // Error message
                                                                                                            ),
                                                                                                        );
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window
                                                                                                    } else {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'Se ha realizado la transferencia satisfactoriamente. ', // Success message
                                                                                                            ),
                                                                                                        );
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'button', // Cancel button
                                                                                value: _('Cancelar'), // Button text
                                                                                click: function(elementId, event) {
                                                                                    this.getTopParentView().hide(); // Hide window
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                            move: true, // Allow moving the window
                                                        })
                                                        .show(); // Show the window
                                                    break;
                                                case '1': // Transfer to game balance
                                                    webix
                                                        .ui({
                                                            view: 'window', // Window view
                                                            head: _('Transferir a Saldo Juego a ') + item.UserName, // Window header
                                                            id: 'windowTransfers', // Window ID
                                                            modal: true, // Modal window
                                                            position: 'center', // Center position
                                                            body: {
                                                                view: 'form', // Form view
                                                                id: 'windowTransfersForm', // Form ID
                                                                elements: [
                                                                    {
                                                                        view: 'text', // Text input for amount
                                                                        label: _('Monto'), // Label for input
                                                                        name: 'amount', // Input name
                                                                        id: 'amount', // Input ID
                                                                    },
                                                                    {
                                                                        cols: [ // Button layout
                                                                            {
                                                                                view: 'button', // Transfer button
                                                                                value: 'Transferir', // Button text
                                                                                click: function(elementId, event) {
                                                                                    var values =
                                                                                        $(
                                                                                            'windowTransfersForm', // Get form values
                                                                                        ).getValues();
                                                                                    var tthis = this; // Preserve context
                                                                                    webix
                                                                                        .ajax()
                                                                                        .headers({
                                                                                            'Content-type':
                                                                                                'application/json', // Set content type
                                                                                        })
                                                                                        .post(
                                                                                            devConfig.geturlApi() +
                                                                                            'Agent/MakeAgentTransfers',
                                                                                            '{ "Id":' +
                                                                                            item.Id +
                                                                                            ',"Amount":' +
                                                                                            values.amount +
                                                                                            ',"Type":1}', // Transfer data
                                                                                            {
                                                                                                error: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        _('Error! '), // Show error message
                                                                                                    );
                                                                                                },
                                                                                                success: function(
                                                                                                    text,
                                                                                                    data,
                                                                                                    XmlHttpRequest,
                                                                                                ) {
                                                                                                    var data =
                                                                                                        JSON.parse(
                                                                                                            text, // Parse response
                                                                                                        );
                                                                                                    if (data.HasError) {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'No Se ha realizado la transferencia. Comunicarse con soporte. ', // Error message
                                                                                                            ),
                                                                                                        );
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window
                                                                                                    } else {
                                                                                                        webix.message(
                                                                                                            _(
                                                                                                                'Se ha realizado la transferencia satisfactoriamente. ', // Success message
                                                                                                            ),
                                                                                                        );
                                                                                                        tthis
                                                                                                            .getTopParentView()
                                                                                                            .hide(); // Hide window
                                                                                                    }
                                                                                                },
                                                                                            },
                                                                                        );
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'button', // Cancel button
                                                                                value: _('Cancelar'), // Button text
                                                                                click: function(elementId, event) {
                                                                                    this.getTopParentView().hide(); // Hide window
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                            move: true, // Allow moving the window
                                                        })
                                                        .show(); // Show the window
                                                    break;
                                                case '2': // Cancel action
                                                    break; // Do nothing
                                            }
                                        });
                                },
                            },
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Initialize the grid component for the data table
        grid = $$('datatable');

        // Construct the API URL for fetching agents
        var url = devConfig.geturlApi() + 'Agent/GetAgentsTwoLevels';

        // Initialize an empty filter string
        var filter = '';

        // Get the localization service
        const _ = this.app.getService('locale')._;

        // Listen for the 'agentList:filter' event to apply filters to the grid
        this.on(this.app, 'agentList:filter', (filterData) => {
            // Convert filterData object entries into an array
            var object = Object.entries(filterData);
            var string1 = '';

            // Iterate through each filter entry
            for (var i = 0; i < object.length; i++) {
                // Check if the filter value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filter
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle object type filters
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        // Iterate through the nested filter object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the filter value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date filter
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle 'end' date filter
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Log the constructed filter string
            console.log(string1);
            // Clear the grid data
            grid.clearAll();
            // Load the grid with the filtered data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the current filter string
            filter = string1;
            // Hide the filter popup
            $$('filterPopup').hide();
        });

        // Attach an event handler for sorting the grid
        grid.attachEvent('onAfterSort', function(by, dir, as) {
            // Load the grid with sorted data
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event handler for starting an edit on a grid item
        grid.attachEvent('onBeforeEditStart', function(id) {
            // Get the item being edited
            var item = this.getItem(id);
            console.log(item);
            // Check if the edited column is 'Action'
            if (id.column == 'Action') {
                var options = this.getColumnConfig('Action').collection;
                // Prevent editing if the item's StateValidate is not 'N'
                if (item.StateValidate != 'N') {
                    console.log(item);
                    return false;
                }
                console.log(id);
            }
        });

        // Listen for the 'player:select' event to filter grid by PlayerId
        this.on(this.app, 'player:select', (Id) => {
            // Load the grid with data filtered by PlayerId
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
